import { observeDiagnosticRequest } from './diagnostics'
import { getApiOrigin } from './runtimeOrigins'

const API_ORIGIN = getApiOrigin()

const lookupCache = new Map()

export const normalizeZip = value => {
    const match = String(value || '').trim().match(/^(\d{5})(?:-\d{4})?$/)
    return match?.[1] || ''
}

export const clearZipLookupCache = () => lookupCache.clear()

export const lookupZip = async (value, { originZip } = {}) => {
    const zip = normalizeZip(value)
    const origin = normalizeZip(originZip)
    if (!zip) return { valid: false, zip: '' }

    const cacheKey = `${zip}:${origin}`
    if (lookupCache.has(cacheKey)) return lookupCache.get(cacheKey)

    const request = observeDiagnosticRequest({ url: `${API_ORIGIN}/location/zip`, method: 'GET' }, () => fetch(`${API_ORIGIN}/location/zip?${new URLSearchParams({
        zip,
        ...(origin ? { origin } : {}),
    })}`, {
        credentials: 'include',
        headers: { Accept: 'application/json' },
    })).then(async response => {
        if (!response.ok) throw new Error('ZIP lookup is temporarily unavailable.')
        return response.json()
    }).catch(error => {
        lookupCache.delete(cacheKey)
        throw error
    })

    lookupCache.set(cacheKey, request)
    return request
}

export const validateZip = async value => {
    try {
        return Boolean((await lookupZip(value)).valid)
    } catch (error) {
        return false
    }
}
